<!--抄表管理信息列表电表 meterManager-->
<template>
  <div class="mymetermanager" style="padding: 10px;">
    <div class="con">
      <div class="search-input-btn" style="width:100%">
        <el-scrollbar style="height:100%;width: 100%;">
          <div class="my-search-i">
            <div class="input-small mr-20">
              <span>设备名：</span>
              <el-input
                v-model="findDeviceName"
                placeholder="请输入设备名"
                style="width:140px"
              ></el-input>
            </div>
            <div class="input-small mr-20">
              <span>设备SN编码：</span>
              <el-input
                v-model="deviceNo"
                placeholder="请输入设备编号"
                style="width:140px"
              ></el-input>
            </div>
            <div class="input-small mr-20">
              <span>业主姓名：</span>
              <el-input
                v-model="ownerName"
                placeholder="请输入业主姓名"
                style="width:140px"
              ></el-input>
            </div>

            <div class="input-small mr-20 myinput-mill">
              <span>开户状态：</span>
              <el-select
                v-model="state"
                clearable
                placeholder="请选择"
                style="width: 90px;"
              >
                <el-option
                  v-for="item in relevanceStatusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <div class="input-small mr-20 myinput-mill">
              <span>联网状态：</span>
              <el-select
                v-model="deviceState"
                clearable
                placeholder="请选择"
                style="width: 90px;"
              >
                <el-option
                  v-for="item in connectStatusList"
                  :key="item.value"
                  :label="item.label"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </div>
            <el-button
              type="primary"
              plain
              @click="getDataList"
              class="search-btn"
              >查询</el-button
            >
            <el-button type="primary" @click="addMeterSet" class="search-btn"
              >新增</el-button
            >
            <el-button type="primary" @click="exportReport" class="search-btn"
              >导出</el-button
            >
          </div>
        </el-scrollbar>
      </div>

      <div class="mytable" :style="{ height: heights + 'px' }">
        <el-table
          :data="dataList"
          :height="heights - 20"
          border
          style="width: 100%;"
          stripe
          @selection-change="handleSelectionChange"
        >
          <template slot="empty">
            <span class="noData">
              <img src="@/assets/noData.png" alt="暂无数据" />
              <span class="text">暂无数据</span>
            </span>
          </template>
          <el-table-column type="selection" width="50" align="center">
          </el-table-column>
          <el-table-column
            type="index"
            width="50"
            label="序号"
            fixed
            align="center"
          >
          </el-table-column>
          <el-table-column prop="sn" label="设备SN编码" width="140">
          </el-table-column>
          <el-table-column prop="deviceName" label="设备名称" min-width="170">
          </el-table-column>
          <el-table-column label="设备别名(双击修改)" min-width="170">
            <template slot-scope="scope">
              <span
                @dblclick="bieming(scope.row)"
                v-show="!scope.row.inputed"
                style="min-width: 100px;display: block;height: 30px;"
                >{{ scope.row.deviceAlias }}</span
              >
              <el-input
                v-if="scope.row.inputed"
                v-model="scope.row.deviceAlias"
                placeholder="请输入设备名"
                @blur="bieming2(scope.row)"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="userName" label="业主姓名" width="140">
          </el-table-column>
          <el-table-column label="抄表时间" width="160" align="center">
            <template slot-scope="scope">
              <span>{{ scope.row.meterReadingStartTime }}</span>
            </template>
          </el-table-column>

          <el-table-column
            prop="accountType"
            label="付费方式"
            width="110"
            align="center"
          >
            <template slot-scope="scope">
              <span v-show="scope.row.accountType == '0'">后付费</span>
              <span v-show="scope.row.accountType == '1'">预付费</span>
              <span v-show="scope.row.accountType == '2'">预付费-月账单</span>
              <span
                v-show="
                  scope.row.accountType == undefined ||
                    scope.row.accountType == ''
                "
                >-</span
              >
            </template>
          </el-table-column>
          <el-table-column
            prop="state"
            label="是否开户"
            width="80"
            align="center"
          >
            <template slot-scope="scope">
              <span class="wrongStatus" v-show="scope.row.state == 0"
                >未开户</span
              >
              <span class="wrongStatus" v-show="scope.row.state == -1"
                >欠费中</span
              >
              <span
                class="normalStatus"
                v-show="scope.row.state == undefined || scope.row.state == null"
                >-</span
              >
              <span class="normalStatus" v-show="scope.row.state == 1"
                >已开户</span
              >
            </template>
          </el-table-column>

          <el-table-column
            prop="deviceState"
            label="联网"
            width="70"
            align="center"
          >
            <template slot-scope="scope">
              <span class="normalStatus" v-show="scope.row.deviceState == 1"
                >在线</span
              >
              <span class="wrongStatus" v-show="scope.row.deviceState != 1"
                >离线</span
              >
            </template>
          </el-table-column>
          <!-- <el-table-column prop="state232" label="开合闸状态" width="100">
              <template slot-scope="scope">
                <img :src="getDeviceStateSource(scope.row.state232)" alt="" />
              </template>
            </el-table-column> -->
          <el-table-column label="操作" width="180" align="center">
            <template slot-scope="scope">
              <el-button
                size="mini"
                type="primary"
                @click="viewDetails(scope.row)"
                plain
                >详情</el-button
              >
              <!-- <el-button size="mini" type="primary" v-if="getDeviceStateSource2(scope.row.state232)"
                  @click="onOffState(scope.row,0)" plain>开</el-button>
                <el-button size="mini" type="danger" v-else @click="onOffState(scope.row,1)" plain>关</el-button> -->
              <el-button
                size="mini"
                type="danger"
                class="last-el-button"
                @click="deleteMeter(scope.row)"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="divider-line"></div>
      <!--分页-->
      <elPagination
        :total="total"
        :pageSize="pageSize"
        @pageindexChange="pageindexChange"
        @handleSizeChange="handleSizeChange"
      />
    </div>
    <VerifyPasswordDialog ref="verifyPasswordDialog"></VerifyPasswordDialog>
    <AddNewMeterDialog
      ref="addNewMeterDialog"
      @successList="getDataList"
    ></AddNewMeterDialog>
  </div>
</template>

<script>
import infoListMultipleSelection from "./infoListMultipleSelection.vue";
import VerifyPasswordDialog from "./dialogs/VerifyPasswordDialog.vue";
import AddNewMeterDialog from "./dialogs/AddNewMeterDialog.vue";
import meterManagerStore from "./meterManagerStore.js";
import elPagination from "@/components/module/elComponents/elPagination.vue";
import request from "@/api/http.js";
export default {
  components: {
    infoListMultipleSelection,
    VerifyPasswordDialog,
    AddNewMeterDialog,
    elPagination,
  },
  props: {},
  data() {
    return {
      deviceState2: "",
      heights: document.getElementById("app").clientHeight - 240,
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      dataList: [
        {
          amountOfArrears: null,
          freeQuota: 0,
          meterReadingStatus: "ENABLE",
          maxEndElectric: 278.7,
          deductionStandard: null,
          deviceName: "129",
          lastDeductionFeeTime: null,
          balance: 68493,
          entityName: "MeterReadingConfig",
          id: "142",
          meterRunType: 2,
          state: 1,
          minBeginTime: 1698742834e3,
          useElectric: 278.7,
          accountType: "1",
          userBingdingTime: 1698920442e3,
          balanceAlarm: 1e4,
          deviceNo: 142,
          electricQuantity: 12.3,
          generallyName: "129",
          surplusQuota: null,
          isAutomaticBrake: 1,
          deviceState: 1,
          cardNumber: null,
          billingMode: "SingleBilling",
          deviceAlias: null,
          firstRealDeductionFeeTime: null,
          bankName: null,
          billingModePkid: 0xfe0f53d3c001,
          realAmount: 0,
          meterReadingStartTime: 16987428e5,
          deductionFeeDay: 1,
          sn: "202307130113",
          basicElectricityCharges: 0,
          amount: 984,
          cardType: null,
          maxEndTime: 17154936e5,
          minBeginMeterReading: 4140.6,
          userName: "麦当劳",
          userBalanceSum: 1231444.64,
          conversionRate: null,
          userId: "4831a8f321f8498487166c8202daeb87",
          state232: null,
          realElectricQuantity: 0,
          createTime: 1693305021e3,
          meterType: "electric",
          maxEndMeterReading: 18968.8,
          realDeductionFeeTime: null,
          minStartElectric: 0,
        },
        {
          amountOfArrears: null,
          freeQuota: 0,
          meterReadingStatus: "ENABLE",
          maxEndElectric: 269.6,
          deductionStandard: null,
          deviceName: "130",
          lastDeductionFeeTime: null,
          balance: 267716,
          entityName: "MeterReadingConfig",
          id: "143",
          meterRunType: 2,
          state: 1,
          minBeginTime: 1698742835e3,
          useElectric: 269.6,
          accountType: "1",
          userBingdingTime: 1698920442e3,
          balanceAlarm: 1e3,
          deviceNo: 143,
          electricQuantity: 2.9,
          generallyName: "130",
          surplusQuota: null,
          isAutomaticBrake: 1,
          deviceState: 1,
          cardNumber: null,
          billingMode: "SingleBilling",
          deviceAlias: null,
          firstRealDeductionFeeTime: null,
          bankName: null,
          billingModePkid: 0xfe0f53d3c001,
          realAmount: 0,
          meterReadingStartTime: 16987428e5,
          deductionFeeDay: 1,
          sn: "202307130014",
          basicElectricityCharges: 0,
          amount: 232,
          cardType: null,
          maxEndTime: 17154936e5,
          minBeginMeterReading: 3446.1,
          userName: "蜜雪冰城",
          userBalanceSum: 732301.17,
          conversionRate: null,
          userId: "5c2e4d60bd8b48c69cb0565d25f38cea",
          state232: null,
          realElectricQuantity: 0,
          createTime: 1693305021e3,
          meterType: "electric",
          maxEndMeterReading: 12220.2,
          realDeductionFeeTime: null,
          minStartElectric: 0,
        },
        {
          amountOfArrears: null,
          freeQuota: 0,
          meterReadingStatus: "ENABLE",
          maxEndElectric: 106.6,
          deductionStandard: null,
          deviceName: "131",
          lastDeductionFeeTime: null,
          balance: 254460,
          entityName: "MeterReadingConfig",
          id: "144",
          meterRunType: 2,
          state: 1,
          minBeginTime: 1698742836e3,
          useElectric: 106.6,
          accountType: "1",
          userBingdingTime: 1698920442e3,
          balanceAlarm: 1e3,
          deviceNo: 144,
          electricQuantity: 1.4,
          generallyName: "131",
          surplusQuota: null,
          isAutomaticBrake: 0,
          deviceState: 1,
          cardNumber: null,
          billingMode: "SingleBilling",
          deviceAlias: null,
          firstRealDeductionFeeTime: null,
          bankName: null,
          billingModePkid: 0xfe0f53d3c001,
          realAmount: 0,
          meterReadingStartTime: 16987428e5,
          deductionFeeDay: 1,
          sn: "202307130153",
          basicElectricityCharges: 0,
          amount: 112,
          cardType: null,
          maxEndTime: 17154936e5,
          minBeginMeterReading: 2405.4,
          userName: "咖喱荣",
          userBalanceSum: 464368.09,
          conversionRate: null,
          userId: "ea37436f13b14346a0a4ab596a8ac051",
          state232: null,
          realElectricQuantity: 0,
          createTime: 1693305021e3,
          meterType: "electric",
          maxEndMeterReading: 7986,
          realDeductionFeeTime: null,
          minStartElectric: 0,
        },
        {
          amountOfArrears: null,
          freeQuota: 0,
          meterReadingStatus: "ENABLE",
          maxEndElectric: 259.2,
          deductionStandard: null,
          deviceName: "132",
          lastDeductionFeeTime: null,
          balance: 43266,
          entityName: "MeterReadingConfig",
          id: "145",
          meterRunType: 2,
          state: 1,
          minBeginTime: 1698742837e3,
          useElectric: 259.2,
          accountType: "1",
          userBingdingTime: 1698920442e3,
          balanceAlarm: 1e3,
          deviceNo: 145,
          electricQuantity: 3.3,
          generallyName: "132",
          surplusQuota: null,
          isAutomaticBrake: 0,
          deviceState: 1,
          cardNumber: null,
          billingMode: "SingleBilling",
          deviceAlias: null,
          firstRealDeductionFeeTime: null,
          bankName: null,
          billingModePkid: 0xfe0f53d3c001,
          realAmount: 0,
          meterReadingStartTime: 16987428e5,
          deductionFeeDay: 1,
          sn: "202307130041",
          basicElectricityCharges: 0,
          amount: 264,
          cardType: null,
          maxEndTime: 17154936e5,
          minBeginMeterReading: 5346.1,
          userName: "淘乐屋",
          userBalanceSum: 1106802.62,
          conversionRate: null,
          userId: "2e0e427b294241a48a16063b39389d39",
          state232: null,
          realElectricQuantity: 0,
          createTime: 1693305021e3,
          meterType: "electric",
          maxEndMeterReading: 18648.3,
          realDeductionFeeTime: null,
          minStartElectric: 0,
        },
        {
          amountOfArrears: null,
          freeQuota: 0,
          meterReadingStatus: "ENABLE",
          maxEndElectric: 248.6,
          deductionStandard: null,
          deviceName: "133",
          lastDeductionFeeTime: null,
          balance: 115043,
          entityName: "MeterReadingConfig",
          id: "146",
          meterRunType: 2,
          state: 1,
          minBeginTime: 1698742838e3,
          useElectric: 248.6,
          accountType: "1",
          userBingdingTime: 1698920442e3,
          balanceAlarm: 1e3,
          deviceNo: 146,
          electricQuantity: 1.4,
          generallyName: "133",
          surplusQuota: null,
          isAutomaticBrake: 0,
          deviceState: 1,
          cardNumber: null,
          billingMode: "SingleBilling",
          deviceAlias: null,
          firstRealDeductionFeeTime: null,
          bankName: null,
          billingModePkid: 0xfe0f53d3c001,
          realAmount: 0,
          meterReadingStartTime: 16987428e5,
          deductionFeeDay: 1,
          sn: "202307130087",
          basicElectricityCharges: 0,
          amount: 112,
          cardType: null,
          maxEndTime: 17154936e5,
          minBeginMeterReading: 5672.6,
          userName: "简也",
          userBalanceSum: 884946.29,
          conversionRate: null,
          userId: "6470a0507e3b4c269f06527a3f8acdd6",
          state232: null,
          realElectricQuantity: 0,
          createTime: 1693305021e3,
          meterType: "electric",
          maxEndMeterReading: 16313.2,
          realDeductionFeeTime: null,
          minStartElectric: 0,
        },
        {
          amountOfArrears: null,
          freeQuota: 0,
          meterReadingStatus: "ENABLE",
          maxEndElectric: 550.2,
          deductionStandard: null,
          deviceName: "134",
          lastDeductionFeeTime: null,
          balance: 172528,
          entityName: "MeterReadingConfig",
          id: "147",
          meterRunType: 2,
          state: 1,
          minBeginTime: 1698742839e3,
          useElectric: 550.2,
          accountType: "1",
          userBingdingTime: 1698920442e3,
          balanceAlarm: 1e3,
          deviceNo: 147,
          electricQuantity: 4.4,
          generallyName: "134",
          surplusQuota: null,
          isAutomaticBrake: 0,
          deviceState: 1,
          cardNumber: null,
          billingMode: "SingleBilling",
          deviceAlias: null,
          firstRealDeductionFeeTime: null,
          bankName: null,
          billingModePkid: 0xfe0f53d3c001,
          realAmount: 0,
          meterReadingStartTime: 16987428e5,
          deductionFeeDay: 1,
          sn: "202307130038",
          basicElectricityCharges: 0,
          amount: 352,
          cardType: null,
          maxEndTime: 17154936e5,
          minBeginMeterReading: 8792.8,
          userName: "大利来记",
          userBalanceSum: 1527480.25,
          conversionRate: null,
          userId: "bfa0ad2610f84784bf08638e98c3595e",
          state232: null,
          realElectricQuantity: 0,
          createTime: 1693305021e3,
          meterType: "electric",
          maxEndMeterReading: 27150.6,
          realDeductionFeeTime: null,
          minStartElectric: 0,
        },
        {
          amountOfArrears: null,
          freeQuota: 0,
          meterReadingStatus: "ENABLE",
          maxEndElectric: 541.8,
          deductionStandard: null,
          deviceName: "135",
          lastDeductionFeeTime: null,
          balance: 98686,
          entityName: "MeterReadingConfig",
          id: "148",
          meterRunType: 2,
          state: 1,
          minBeginTime: 169874284e4,
          useElectric: 541.8,
          accountType: "1",
          userBingdingTime: 1698920442e3,
          balanceAlarm: 1e3,
          deviceNo: 148,
          electricQuantity: 7,
          generallyName: "135",
          surplusQuota: null,
          isAutomaticBrake: 0,
          deviceState: 1,
          cardNumber: null,
          billingMode: "SingleBilling",
          deviceAlias: null,
          firstRealDeductionFeeTime: null,
          bankName: null,
          billingModePkid: 0xfe0f53d3c001,
          realAmount: 0,
          meterReadingStartTime: 16987428e5,
          deductionFeeDay: 1,
          sn: "202307130127",
          basicElectricityCharges: 0,
          amount: 560,
          cardType: null,
          maxEndTime: 17154936e5,
          minBeginMeterReading: 10537.6,
          userName: "ART艺闪",
          userBalanceSum: 1491378.12,
          conversionRate: null,
          userId: "b6c584a9520243b4acb5631d7b30af2d",
          state232: null,
          realElectricQuantity: 0,
          createTime: 1693305021e3,
          meterType: "electric",
          maxEndMeterReading: 28517.9,
          realDeductionFeeTime: null,
          minStartElectric: 0,
        },
        {
          amountOfArrears: null,
          freeQuota: 0,
          meterReadingStatus: "ENABLE",
          maxEndElectric: 938.2,
          deductionStandard: null,
          deviceName: "136",
          lastDeductionFeeTime: null,
          balance: 430008,
          entityName: "MeterReadingConfig",
          id: "149",
          meterRunType: 2,
          state: 1,
          minBeginTime: 16988293e5,
          useElectric: 938.2,
          accountType: "1",
          userBingdingTime: 1698920442e3,
          balanceAlarm: 1e3,
          deviceNo: 149,
          electricQuantity: 9,
          generallyName: "136",
          surplusQuota: null,
          isAutomaticBrake: 0,
          deviceState: 1,
          cardNumber: null,
          billingMode: "SingleBilling",
          deviceAlias: null,
          firstRealDeductionFeeTime: null,
          bankName: null,
          billingModePkid: 0xfe0f53d3c001,
          realAmount: 0,
          meterReadingStartTime: 16988292e5,
          deductionFeeDay: 1,
          sn: "202307130032",
          basicElectricityCharges: 0,
          amount: 720,
          cardType: null,
          maxEndTime: 17154936e5,
          minBeginMeterReading: 24112.4,
          userName: "青岛啤酒",
          userBalanceSum: 2270005.92,
          conversionRate: null,
          userId: "0f988c278cb4483ba4fc701cb8b46904",
          state232: null,
          realElectricQuantity: 0,
          createTime: 1693305021e3,
          meterType: "electric",
          maxEndMeterReading: 51480.2,
          realDeductionFeeTime: null,
          minStartElectric: 0,
        },
        {
          amountOfArrears: null,
          freeQuota: 0,
          meterReadingStatus: "ENABLE",
          maxEndElectric: 496,
          deductionStandard: null,
          deviceName: "137",
          lastDeductionFeeTime: null,
          balance: 210915,
          entityName: "MeterReadingConfig",
          id: "150",
          meterRunType: 2,
          state: 1,
          minBeginTime: 1701486104e3,
          useElectric: 496,
          accountType: "1",
          userBingdingTime: 1698920442e3,
          balanceAlarm: 1e3,
          deviceNo: 150,
          electricQuantity: 3.6,
          generallyName: "137",
          surplusQuota: null,
          isAutomaticBrake: 0,
          deviceState: 1,
          cardNumber: null,
          billingMode: "SingleBilling",
          deviceAlias: null,
          firstRealDeductionFeeTime: null,
          bankName: null,
          billingModePkid: 0xfe0f53d3c001,
          realAmount: 0,
          meterReadingStartTime: 1701486e6,
          deductionFeeDay: 1,
          sn: "202307130149",
          basicElectricityCharges: 0,
          amount: 288,
          cardType: null,
          maxEndTime: 17154936e5,
          minBeginMeterReading: 10922,
          userName: "太平洋咖啡",
          userBalanceSum: 1373039.79,
          conversionRate: null,
          userId: "9655cd3c33b24f12a2a43e7a1866cbe4",
          state232: null,
          realElectricQuantity: 0,
          createTime: 1693305021e3,
          meterType: "electric",
          maxEndMeterReading: 27454.2,
          realDeductionFeeTime: null,
          minStartElectric: 0,
        },
        {
          amountOfArrears: null,
          freeQuota: 0,
          meterReadingStatus: "ENABLE",
          maxEndElectric: 314,
          deductionStandard: null,
          deviceName: "138",
          lastDeductionFeeTime: null,
          balance: 210915,
          entityName: "MeterReadingConfig",
          id: "151",
          meterRunType: 2,
          state: 1,
          minBeginTime: 1701486105e3,
          useElectric: 314,
          accountType: "1",
          userBingdingTime: 1698920442e3,
          balanceAlarm: 1e3,
          deviceNo: 151,
          electricQuantity: 11,
          generallyName: "138",
          surplusQuota: null,
          isAutomaticBrake: 0,
          deviceState: 1,
          cardNumber: null,
          billingMode: "SingleBilling",
          deviceAlias: null,
          firstRealDeductionFeeTime: null,
          bankName: null,
          billingModePkid: 0xfe0f53d3c001,
          realAmount: 0,
          meterReadingStartTime: 1701486e6,
          deductionFeeDay: 1,
          sn: "202307130008",
          basicElectricityCharges: 0,
          amount: 880,
          cardType: null,
          maxEndTime: 17154936e5,
          minBeginMeterReading: 15929.4,
          userName: "太平洋咖啡",
          userBalanceSum: 916047.75,
          conversionRate: null,
          userId: "9655cd3c33b24f12a2a43e7a1866cbe4",
          state232: null,
          realElectricQuantity: 0,
          createTime: 1693305021e3,
          meterType: "electric",
          maxEndMeterReading: 27004,
          realDeductionFeeTime: null,
          minStartElectric: 0,
        },
        {
          amountOfArrears: null,
          freeQuota: 0,
          meterReadingStatus: "ENABLE",
          maxEndElectric: 1015.6,
          deductionStandard: null,
          deviceName: "139",
          lastDeductionFeeTime: null,
          balance: 452983,
          entityName: "MeterReadingConfig",
          id: "152",
          meterRunType: 2,
          state: 1,
          minBeginTime: 1701342104e3,
          useElectric: 1015.6,
          accountType: "1",
          userBingdingTime: 1698920442e3,
          balanceAlarm: 1e3,
          deviceNo: 152,
          electricQuantity: 14,
          generallyName: "139",
          surplusQuota: null,
          isAutomaticBrake: 0,
          deviceState: 1,
          cardNumber: null,
          billingMode: "SingleBilling",
          deviceAlias: null,
          firstRealDeductionFeeTime: null,
          bankName: null,
          billingModePkid: 0xfe0f53d3c001,
          realAmount: 0,
          meterReadingStartTime: 1701342e6,
          deductionFeeDay: 1,
          sn: "202307130018",
          basicElectricityCharges: 0,
          amount: 1120,
          cardType: null,
          maxEndTime: 17154936e5,
          minBeginMeterReading: 25764.8,
          userName: "多乐之日",
          userBalanceSum: 3226915.97,
          conversionRate: null,
          userId: "59f58c66310942598e2caf463bd71087",
          state232: null,
          realElectricQuantity: 0,
          createTime: 1693305021e3,
          meterType: "electric",
          maxEndMeterReading: 64546.8,
          realDeductionFeeTime: null,
          minStartElectric: 0,
        },
        {
          amountOfArrears: null,
          freeQuota: 0,
          meterReadingStatus: "ENABLE",
          maxEndElectric: 684,
          deductionStandard: null,
          deviceName: "140",
          lastDeductionFeeTime: null,
          balance: -6753,
          entityName: "MeterReadingConfig",
          id: "153",
          meterRunType: 2,
          state: 1,
          minBeginTime: 1698742841e3,
          useElectric: 684,
          accountType: "1",
          userBingdingTime: 1698920442e3,
          balanceAlarm: 1e3,
          deviceNo: 153,
          electricQuantity: 16.2,
          generallyName: "140",
          surplusQuota: null,
          isAutomaticBrake: 0,
          deviceState: 1,
          cardNumber: null,
          billingMode: "SingleBilling",
          deviceAlias: null,
          firstRealDeductionFeeTime: null,
          bankName: null,
          billingModePkid: 0xfe0f53d3c001,
          realAmount: 0,
          meterReadingStartTime: 16987428e5,
          deductionFeeDay: 1,
          sn: "202307130132",
          basicElectricityCharges: 0,
          amount: 1296,
          cardType: null,
          maxEndTime: 17154936e5,
          minBeginMeterReading: 14417.2,
          userName: "七日可见",
          userBalanceSum: 2106753.17,
          conversionRate: null,
          userId: "76f6db57e3904abdb70f298c8e373b83",
          state232: null,
          realElectricQuantity: 0,
          createTime: 1693305043e3,
          meterType: "electric",
          maxEndMeterReading: 39802.6,
          realDeductionFeeTime: null,
          minStartElectric: 0,
        },
        {
          amountOfArrears: null,
          freeQuota: 0,
          meterReadingStatus: "ENABLE",
          maxEndElectric: 478,
          deductionStandard: null,
          deviceName: "141",
          lastDeductionFeeTime: null,
          balance: 786290,
          entityName: "MeterReadingConfig",
          id: "154",
          meterRunType: 2,
          state: 1,
          minBeginTime: 1701342106e3,
          useElectric: 478,
          accountType: "1",
          userBingdingTime: 1698920442e3,
          balanceAlarm: 1e3,
          deviceNo: 154,
          electricQuantity: 7.6,
          generallyName: "141",
          surplusQuota: null,
          isAutomaticBrake: 1,
          deviceState: 1,
          cardNumber: null,
          billingMode: "SingleBilling",
          deviceAlias: null,
          firstRealDeductionFeeTime: null,
          bankName: null,
          billingModePkid: 0xfe0f53d3c001,
          realAmount: 0,
          meterReadingStartTime: 1701342e6,
          deductionFeeDay: 1,
          sn: "202307130017",
          basicElectricityCharges: 0,
          amount: 608,
          cardType: null,
          maxEndTime: 17154936e5,
          minBeginMeterReading: 13577.8,
          userName: "喜市多",
          userBalanceSum: 1594408.98,
          conversionRate: null,
          userId: "48579259953048b2a23ffd513f6b156c",
          state232: null,
          realElectricQuantity: 0,
          createTime: 1693305043e3,
          meterType: "electric",
          maxEndMeterReading: 32762,
          realDeductionFeeTime: null,
          minStartElectric: 0,
        },
        {
          amountOfArrears: null,
          freeQuota: 0,
          meterReadingStatus: "ENABLE",
          maxEndElectric: 503.2,
          deductionStandard: null,
          deviceName: "142",
          lastDeductionFeeTime: null,
          balance: 39290,
          entityName: "MeterReadingConfig",
          id: "155",
          meterRunType: 2,
          state: 1,
          minBeginTime: 1698742842e3,
          useElectric: 503.2,
          accountType: "1",
          userBingdingTime: 1698920442e3,
          balanceAlarm: 1e3,
          deviceNo: 155,
          electricQuantity: 7.2,
          generallyName: "142",
          surplusQuota: null,
          isAutomaticBrake: 0,
          deviceState: 1,
          cardNumber: null,
          billingMode: "SingleBilling",
          deviceAlias: null,
          firstRealDeductionFeeTime: null,
          bankName: null,
          billingModePkid: 0xfe0f53d3c001,
          realAmount: 0,
          meterReadingStartTime: 16987428e5,
          deductionFeeDay: 1,
          sn: "202307130058",
          basicElectricityCharges: 0,
          amount: 576,
          cardType: null,
          maxEndTime: 17154936e5,
          minBeginMeterReading: 8931.2,
          userName: "DQ",
          userBalanceSum: 1936752.04,
          conversionRate: null,
          userId: "faf2f16d6ed041aa8df99c1b7463173b",
          state232: null,
          realElectricQuantity: 0,
          createTime: 1693305043e3,
          meterType: "electric",
          maxEndMeterReading: 32225.6,
          realDeductionFeeTime: null,
          minStartElectric: 0,
        },
        {
          amountOfArrears: null,
          freeQuota: 0,
          meterReadingStatus: "DISABLE",
          maxEndElectric: null,
          deductionStandard: null,
          deviceName: "143",
          lastDeductionFeeTime: null,
          balance: 0,
          entityName: "MeterReadingConfig",
          id: "156",
          meterRunType: 2,
          state: 1,
          minBeginTime: null,
          useElectric: 0,
          accountType: "1",
          userBingdingTime: 1698920442e3,
          balanceAlarm: 1e3,
          deviceNo: 156,
          electricQuantity: null,
          generallyName: "143",
          surplusQuota: null,
          isAutomaticBrake: 0,
          deviceState: 1,
          cardNumber: null,
          billingMode: "SingleBilling",
          deviceAlias: null,
          firstRealDeductionFeeTime: null,
          bankName: null,
          billingModePkid: 0xfe0f53d3c001,
          realAmount: 0,
          meterReadingStartTime: null,
          deductionFeeDay: 1,
          sn: "202307130016",
          basicElectricityCharges: 0,
          amount: null,
          cardType: null,
          maxEndTime: null,
          minBeginMeterReading: null,
          userName: "KFC",
          userBalanceSum: 0,
          conversionRate: null,
          userId: "7b7d1285b4eb48c1a141bda5ec8872a8",
          state232: null,
          realElectricQuantity: 0,
          createTime: 1693305043e3,
          meterType: "electric",
          maxEndMeterReading: null,
          realDeductionFeeTime: null,
          minStartElectric: null,
        },
        {
          amountOfArrears: null,
          freeQuota: 0,
          meterReadingStatus: "ENABLE",
          maxEndElectric: 177.5,
          deductionStandard: null,
          deviceName: "144",
          lastDeductionFeeTime: null,
          balance: 1520912,
          entityName: "MeterReadingConfig",
          id: "157",
          meterRunType: 2,
          state: 1,
          minBeginTime: 1701342108e3,
          useElectric: 177.5,
          accountType: "1",
          userBingdingTime: 1698920442e3,
          balanceAlarm: 1e3,
          deviceNo: 157,
          electricQuantity: 0,
          generallyName: "144",
          surplusQuota: null,
          isAutomaticBrake: 0,
          deviceState: 1,
          cardNumber: null,
          billingMode: "SingleBilling",
          deviceAlias: null,
          firstRealDeductionFeeTime: null,
          bankName: null,
          billingModePkid: 0xfe0f53d3c001,
          realAmount: 0,
          meterReadingStartTime: 1701342e6,
          deductionFeeDay: 1,
          sn: "202307130108",
          basicElectricityCharges: 0,
          amount: 0,
          cardType: null,
          maxEndTime: 17154936e5,
          minBeginMeterReading: 6177.5,
          userName: "蔚来铺内",
          userBalanceSum: 456127.11,
          conversionRate: null,
          userId: "058a4fd86d8745c29c312eccb6117355",
          state232: null,
          realElectricQuantity: 0,
          createTime: 1693305043e3,
          meterType: "electric",
          maxEndMeterReading: 11627.5,
          realDeductionFeeTime: null,
          minStartElectric: 0,
        },
        {
          amountOfArrears: null,
          freeQuota: 0,
          meterReadingStatus: "DISABLE",
          maxEndElectric: 590.5,
          deductionStandard: null,
          deviceName: "145",
          lastDeductionFeeTime: null,
          balance: 751683,
          entityName: "MeterReadingConfig",
          id: "158",
          meterRunType: 2,
          state: 0,
          minBeginTime: 1698742843e3,
          useElectric: 590.5,
          accountType: "1",
          userBingdingTime: 1698920442e3,
          balanceAlarm: 1e3,
          deviceNo: 158,
          electricQuantity: 0,
          generallyName: "145",
          surplusQuota: null,
          isAutomaticBrake: 1,
          deviceState: 0,
          cardNumber: null,
          billingMode: "SingleBilling",
          deviceAlias: null,
          firstRealDeductionFeeTime: null,
          bankName: null,
          billingModePkid: 0xfe0f53d3c001,
          realAmount: 0,
          meterReadingStartTime: null,
          deductionFeeDay: 1,
          sn: "202307130007",
          basicElectricityCharges: 0,
          amount: 0,
          cardType: null,
          maxEndTime: 17064108e5,
          minBeginMeterReading: 11288.5,
          userName: "懂鹅",
          userBalanceSum: 1636363.78,
          conversionRate: null,
          userId: "82b0cd05eec544648e3a90b154521b4c",
          state232: null,
          realElectricQuantity: 0,
          createTime: 1693305043e3,
          meterType: "electric",
          maxEndMeterReading: 30907.5,
          realDeductionFeeTime: null,
          minStartElectric: 0,
        },
        {
          amountOfArrears: null,
          freeQuota: 0,
          meterReadingStatus: "ENABLE",
          maxEndElectric: 598,
          deductionStandard: null,
          deviceName: "146",
          lastDeductionFeeTime: null,
          balance: -7846,
          entityName: "MeterReadingConfig",
          id: "159",
          meterRunType: 2,
          state: 1,
          minBeginTime: 1698742844e3,
          useElectric: 598,
          accountType: "1",
          userBingdingTime: 1698920442e3,
          balanceAlarm: 1e3,
          deviceNo: 159,
          electricQuantity: 0,
          generallyName: "146",
          surplusQuota: null,
          isAutomaticBrake: 0,
          deviceState: 1,
          cardNumber: null,
          billingMode: "SingleBilling",
          deviceAlias: null,
          firstRealDeductionFeeTime: null,
          bankName: null,
          billingModePkid: 0xfe0f53d3c001,
          realAmount: 0,
          meterReadingStartTime: 16987428e5,
          deductionFeeDay: 1,
          sn: "202307130145",
          basicElectricityCharges: 0,
          amount: 0,
          cardType: null,
          maxEndTime: 17154936e5,
          minBeginMeterReading: 11907.5,
          userName: "ACLUB",
          userBalanceSum: 1190213.06,
          conversionRate: null,
          userId: "776fc82e0d7e4ddea8a502b848467f2c",
          state232: null,
          realElectricQuantity: 0,
          createTime: 1693305043e3,
          meterType: "electric",
          maxEndMeterReading: 26172.5,
          realDeductionFeeTime: null,
          minStartElectric: 0,
        },
        {
          amountOfArrears: null,
          freeQuota: 0,
          meterReadingStatus: "ENABLE",
          maxEndElectric: 417.5,
          deductionStandard: null,
          deviceName: "147",
          lastDeductionFeeTime: null,
          balance: 24002,
          entityName: "MeterReadingConfig",
          id: "160",
          meterRunType: 2,
          state: 1,
          minBeginTime: 1698742845e3,
          useElectric: 417.5,
          accountType: "1",
          userBingdingTime: 1698920442e3,
          balanceAlarm: 1e3,
          deviceNo: 160,
          electricQuantity: 21.5,
          generallyName: "147",
          surplusQuota: null,
          isAutomaticBrake: 1,
          deviceState: 1,
          cardNumber: null,
          billingMode: "SingleBilling",
          deviceAlias: null,
          firstRealDeductionFeeTime: null,
          bankName: null,
          billingModePkid: 0xfe0f53d3c001,
          realAmount: 0,
          meterReadingStartTime: 16987428e5,
          deductionFeeDay: 1,
          sn: "202307130162",
          basicElectricityCharges: 0,
          amount: 1720,
          cardType: null,
          maxEndTime: 17154936e5,
          minBeginMeterReading: 6984,
          userName: "禾牛道",
          userBalanceSum: 1652656.62,
          conversionRate: null,
          userId: "e3d3189a835c47ccac7469d65c52ce11",
          state232: null,
          realElectricQuantity: 0,
          createTime: 1693305043e3,
          meterType: "electric",
          maxEndMeterReading: 26841,
          realDeductionFeeTime: null,
          minStartElectric: 0,
        },
        {
          amountOfArrears: null,
          freeQuota: 0,
          meterReadingStatus: "ENABLE",
          maxEndElectric: 721.5,
          deductionStandard: null,
          deviceName: "148",
          lastDeductionFeeTime: null,
          balance: 704072,
          entityName: "MeterReadingConfig",
          id: "161",
          meterRunType: 2,
          state: 1,
          minBeginTime: 1698742846e3,
          useElectric: 721.5,
          accountType: "1",
          userBingdingTime: 1698920442e3,
          balanceAlarm: 1e4,
          deviceNo: 161,
          electricQuantity: 11,
          generallyName: "148",
          surplusQuota: null,
          isAutomaticBrake: 1,
          deviceState: 1,
          cardNumber: null,
          billingMode: "SingleBilling",
          deviceAlias: null,
          firstRealDeductionFeeTime: null,
          bankName: null,
          billingModePkid: 0xfe0f53d3c001,
          realAmount: 0,
          meterReadingStartTime: 16987428e5,
          deductionFeeDay: 1,
          sn: "202307130133",
          basicElectricityCharges: 0,
          amount: 880,
          cardType: null,
          maxEndTime: 17154936e5,
          minBeginMeterReading: 11694,
          userName: "意乐坊",
          userBalanceSum: 2781871.94,
          conversionRate: null,
          userId: "9ea77beae41a4c03a5789be61b9eec9f",
          state232: null,
          realElectricQuantity: 0,
          createTime: 1693305043e3,
          meterType: "electric",
          maxEndMeterReading: 45119,
          realDeductionFeeTime: null,
          minStartElectric: 0,
        },
      ],
      deviceNo: "",
      findDeviceName: "",
      ownerName: "",
      state: 1,
      state232: 1,
      userBalanceSum: 1,
      deviceState: 1,
      searchChange: false,
      deductionFeeDay: " ",
      activeName: "first",
      meterType: "electric",
      loading: false, //页面加载
    };
  },
  created() {},
  mounted() {
    this.getDataList();
    meterManagerStore.commit("getAllMeterBillingMode", {
      unitId: this.nowUnit.id,
      activeName: this.activeName,
    });
  },
  destroyed() {},
  computed: {
    nowUser() {
      return this.$store.userStore.state.nowUserInfo;
    },
    nowUnit() {
      return this.$store.unitStore.state.nowUnit;
    },
    nowSelectDate() {
      return this.$store.cacheStore.getters.getNowSelectDate;
    },
    nowTimeInterval() {
      return this.$store.cacheStore.getters.getMeterTimeInterval;
    },
    columns() {
      return meterManagerStore.state.columns;
    },
    userName() {
      return (userName) => {
        return userName == null || userName == "" || userName == undefined
          ? "-"
          : userName;
      };
    },
    electricQuantity() {
      return (electricQuantity) => {
        return electricQuantity == null ||
          electricQuantity == "" ||
          electricQuantity == undefined
          ? "-"
          : electricQuantity;
      };
    },
    deviceName() {
      return (deviceName) => {
        return deviceName;
      };
    },
    amount() {
      return (amount) => {
        return amount == null || amount == "" || amount == undefined
          ? "-"
          : (amount / 100).toFixed(1);
      };
    },
    //实时电费
    realAmount() {
      return (realAmount) => {
        return realAmount == null || realAmount == "" || realAmount == undefined
          ? "-"
          : (realAmount / 100).toFixed(1);
      };
    },
    realElectricQuantity() {
      return (realElectricQuantity) => {
        return realElectricQuantity == null ||
          realElectricQuantity == "" ||
          realElectricQuantity == undefined
          ? "-"
          : realElectricQuantity;
      };
    },
    chargingStatusList() {
      return meterManagerStore.state.chargingStatusList;
    },
    dateDay() {
      let list = [];
      for (let i = 1; i < 32; i++) {
        let obj = {
          label: i + "号",
          value: i,
        };
        list.push(obj);
      }
      return list;
    },
    deviceStatusList() {
      return [
        {
          label: "请选择",
          value: "",
        },
        {
          label: "开闸",
          value: 0,
        },
        {
          label: "合闸",
          value: 1,
        },
      ];
    },
    relevanceStatusList() {
      return [
        {
          label: "未开户",
          value: 0,
        },
        {
          label: "已开户",
          value: 1,
        },
        {
          label: "欠费中",
          value: -1,
        },
      ];
    },
    connectStatusList() {
      return [
        {
          label: "离线",
          value: 0,
        },
        {
          label: "在线",
          value: 1,
        },
      ];
    },
    timeText() {
      return (time) => {
        if (time == null || time == undefined || time == "") {
          return "-";
        }
        return new Date(time).formatByDate();
      };
    },
    getDeviceStateSource() {
      return (state) => {
        if (parseInt(state) == 1) {
          return this.$store.resourcesStore.getters.getResourcesByName(
            "keli/state_on.png"
          );
        } else if (parseInt(state) == 0) {
          return this.$store.resourcesStore.getters.getResourcesByName(
            "keli/state_off.png"
          );
        }
        return this.$store.resourcesStore.getters.getResourcesByName(
          "keli/state_no.png"
        );
      };
    },
    getDeviceStateSource2() {
      return (state) => {
        if (parseInt(state) == 1) {
          return true;
        } else if (parseInt(state) == 0) {
          return false;
        }
        return true;
      };
    },
    timeList() {
      var list = [];
      list.push({
        text: "全部",
        value: "",
      });
      for (let i = 1; i < 32; i++) {
        list.push({
          text: i + "号",
          value: i,
        });
      }
      return list;
    },
  },
  watch: {
    nowUser(nv, ov) {
      meterManagerStore.commit("setNowUser", nv);
    },
    nowUnit(nv, ov) {
      meterManagerStore.commit("setNowUnit", nv);
      this.getDataList(nv);
      meterManagerStore.commit("getAllMeterBillingMode", this.nowUnit.id);
    },
    deviceNo(nv, ov) {
      this.searchChange = true;
    },
    ownerName(nv, ov) {
      this.searchChange = true;
    },
    state(nv, ov) {
      this.searchChange = true;
    },
    deviceState(nv, ov) {
      this.searchChange = true;
    },
    state232(nv, ov) {
      this.searchChange = true;
    },
    nowTimeInterval(nv, ov) {
      this.searchChange = true;
    },
    pageIndex(nv, ov) {
      this.getDataList();
    },
    userBalanceSum(nv, ov) {
      this.userBalanceSum = 0;
    },
  },
  methods: {
    handleSelectionChange(v) {
      console.log(v, 1);
    },
    //当前页
    pageindexChange(val) {
      this.pageIndex = val;
      this.getDataList();
    },
    //页大小
    handleSizeChange(val) {
      this.pageSize = val;
      this.pageIndex = 1;
      this.getDataList();
    },
    compare(name) {
      return function(a, b) {
        //debugger
        var s1 = a[name];
        var s2 = b[name];
        return s1.localeCompare(s2);
      };
    },
    // 操作电表开关
    onOffState(item, state) {
      if (item.deviceState != 1) {
        return;
      }
      // var state=parseInt(item.state232)==1? 1:0
      this.$refs.verifyPasswordDialog.open("密码验证", (password) => {
        this.$api.meterReadingApi.controlMeter(
          item.userId,
          item.deviceNo,
          state,
          password,
          (respon) => {
            this.$set(item, "state232", state);
            this.$dialogMethod.showMessage("操作成功");
          },
          (err) => {
            this.$dialogMethod.showMessage(err);
          }
        );
      });
    },
    // 详情
    viewDetails(item) {
      this.$router.push("/MeterManagerDetails");
    },
    // 修改别名
    bieming2(item) {
      var params = {
        deviceNo: item.deviceNo,
        alias: item.deviceAlias,
      };
      item.inputed = false;
      request({
        url: "meterReading/settingDeviceAlias",
        method: "put",
        params,
      }).then((res) => {
        console.log(res, 111);
      });
    },
    // 显示别名输入框
    bieming(item) {
      item.inputed = true;
    },
    // 删除电表
    deleteMeter(item) {
      //判断业主先解绑、
      this.$dialogMethod.openAgreeDialog(
        "提示",
        "确认删除设备名称：" +
          item.deviceName +
          " 设备编号：" +
          item.deviceNo +
          " 的电表配置？",
        (confirm) => {
          this.$api.meterReadingApi.removeMeterReadingConfig(
            item.deviceNo,
            (respon) => {
              this.$dialogMethod.showMessage(respon);
              meterManagerStore.commit(
                "getMeterReadingConfigList",
                this.nowUnit.id
              );
              this.getDataList();
            },
            (err) => {
              this.$dialogMethod.showMessage(err);
            }
          );
        },
        (cancel) => {
          return;
        },
        true
      );
    },
    // 获取抄表列表信息
    getDataList() {
      console.log("查询");
      if (isempty(this.nowUnit)) {
        return;
      }
      if (this.searchChange) {
        this.pageIndex = 1;
        this.searchChange = false;
      }

      //对参数给值
      this.loading = true;
      this.$api.meterReadingApi.getUnitMeterReadingConfigLimit(
        this.nowUnit.id,
        this.pageIndex,
        this.pageSize,
        this.deviceNo,
        this.findDeviceName,
        this.ownerName,
        this.state,
        this.state232,
        this.deviceState,
        this.deductionFeeDay,
        this.meterType,
        (respon) => {
          this.loading = false;
          var d = copy(respon.dataList.sort(this.compare("deviceName")));
          d.map((v) => {
            if (v.meterReadingStartTime) {
              v.meterReadingStartTime = this.parseTime(
                v.meterReadingStartTime,
                "{y}-{m}-{d} {h}:{i}:{s}"
              );
            }
            if (v.state === 0) {
              v.userName = "";
              console.log(v.deviceName, 111111);
            }
            v.inputed = false;
          });
          this.dataList = d;
          this.total = respon.total;
        }
      );
    },
    // 时间格式化
    parseTime(time, cFormat) {
      if (arguments.length === 0) {
        return null;
      }
      const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
      let date;
      if (typeof time === "object") {
        date = time;
      } else {
        if (typeof time === "string" && /^[0-9]+$/.test(time)) {
          time = parseInt(time);
        }
        if (typeof time === "number" && time.toString().length === 10) {
          time = time * 1000;
        }
        date = new Date(time);
      }
      const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay(),
      };
      const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key];
        // Note: getDay() returns 0 on Sunday
        if (key === "a") {
          return ["日", "一", "二", "三", "四", "五", "六"][value];
        }
        return value.toString().padStart(2, "0");
      });
      return time_str;
    },
    // 添加电表配置
    addMeterSet() {
      this.$refs.addNewMeterDialog.dialogFormVisible = true;
    },
    // 导出报表
    exportReport() {
      if (isempty(this.deductionFeeDay)) {
        this.$dialogMethod.showMessage("请选择抄表日期！");
        return;
      }
      var title = this.nowUnit.name + "电表信息";
      this.$store.cacheStore.state.load = true;
      this.$api.meterReadingApi.exportUnitMeterReadingConfig(
        this.nowUnit.id,
        this.deviceNo,
        this.ownerName,
        this.state,
        this.deductionFeeDay,
        "",
        "electric",
        (respon) => {
          this.$store.cacheStore.state.load = false;
          saveAs(DWSystemSetting.downloadUrl + "/" + respon, title + ".xls");
        }
      );
    },
    // 切换每页显示条数
    pageSizeChange(pageSize) {
      this.pageIndex = 1;
      this.pageSize = pageSize;
      this.getDataList();
    },
    // 切换页码
    jumpToPage(pageIndex) {
      this.pageIndex = pageIndex;
      this.getDataList();
    },
  },
};
</script>

<style scoped lang="scss">
.mymetermanager {
  width: 100%;
  height: 100%;

  .con {
    width: 100%;
    height: 100%;
    padding: 12px 20px;
    background-color: #fff;
    box-sizing: border-box;
  }

  .myinput-mill {
    /deep/.el-input__inner {
      width: 90px;
    }

    /deep/.el-input {
      width: 90px !important;
    }
  }
}

.searchContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  padding-bottom: 0px;
}

.searchContainer > div {
  display: inline-flex;
  flex-wrap: wrap;
  align-items: center;
  flex-grow: 0;
}

.searchContainer label {
  margin-right: 6px;
}

.searchContainer input {
  border-color: #dcdfe6;
  min-width: 130px;
  height: 36px;
  box-sizing: border-box;
  margin-right: 10px;
}

.searchContainer >>> .selection-body {
  display: inline-flex;
  padding: 0;
  margin-right: 20px;
}

.searchContainer >>> .selection > p {
  line-height: 34px;
  height: 34px;
  padding: 0;
}

.selectDateTime {
  display: inline-flex;
  justify-content: space-between;
  align-items: center;
  width: 176px;
  height: 34px;
  padding: 0 6px;
  background: #ffffff;
  border-radius: 6px;
  border: solid 1px #dcdfe6;
  margin-right: 20px;
}

.selectDateTime > span {
  width: 140px;
  line-height: 34px;
  height: 100%;
  cursor: pointer;
}

.selectDateTime > img {
  width: 24px;
  height: 24px;
  cursor: pointer;
}

.searchContainer > button {
  height: 36px;
  background-color: #409eff;
  color: #ffffff;
  padding: 0 18px;
  margin-left: 10px;
  border-radius: 4px;
  flex-shrink: 0;
  cursor: pointer;
}

.infoListContainer {
  /* padding: 0 20px 250px 20px; */
  height: calc(100% - 115px);
}

.infoListContainer::-webkit-scrollbar {
  width: 10px;
  height: 10px;
}

.infoListContainer::-webkit-scrollbar-track {
  box-shadow: none;
  background-color: #ffffff;
}

.infoListContainer:hover::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
  background-color: #f0f0f0;
}

.infoListContainer::-webkit-scrollbar-thumb {
  background-color: #ffffff;
}

.infoListContainer:hover::-webkit-scrollbar-thumb {
  background-color: #cacaca;
}

.normalStatus {
  display: inline-block;
  border: solid 1px #87cf64;
  border-radius: 4px;
  color: #87cf64;
  background-color: #f0f9ec;
  line-height: 28px;
  padding: 0 6px;
}

.wrongStatus {
  display: inline-block;
  border: solid 1px #f9a6a6;
  border-radius: 4px;
  color: #f9a6a6;
  background-color: #fef1f1;
  line-height: 28px;
  padding: 0 6px;
}

.waitStatus {
  display: inline-block;
  border: solid 1px #e6a23c;
  border-radius: 4px;
  color: #e6a23c;
  background-color: #fdf6ec;
  line-height: 28px;
  padding: 0 6px;
}

.normalStatus:hover,
.wrongStatus:hover,
.waitStatus:hover {
  background: #ecf5ff;
  color: #409eff;
  border: solid 1px #409eff;
}

.operateBtn {
  display: inline-block;
  border-radius: 4px;
  line-height: 28px;
  padding: 0 6px;
  background: #ecf5ff;
  color: #409eff;
  border: solid 1px #409eff;
  margin-right: 8px;
  cursor: pointer;
}

.noDrop {
  cursor: no-drop !important;
}

.marginRightNone {
  margin-right: 0;
}

@media screen and (max-width: 1600px) {
  .searchContainer label {
    display: block;
    margin-right: 0;
  }

  .infoListContainer {
    height: calc(100% - 96px);
  }
}
</style>
